import transformUserResponse from '@/features/user/functions/transformUserResponse';
import { User } from '@/features/user/types/user';
import useUnauthenticatedAxios from '@/shared/hooks/useAuthenticatedAxios';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

export default function useGetUserWithAccessToken() {
  const queryClient = useQueryClient();
  const axios = useUnauthenticatedAxios();

  return useCallback(
    (
      data:
        | {
            useCookieStorage: true;
          }
        | {
            useCookieStorage: false;
            token: string;
          }
    ) => {
      return queryClient.fetchQuery<User>({
        retry: 2,
        queryKey: ['user'],
        async queryFn() {
          return axios
            .get(`/api/v1/user`, {
              headers: {
                Authorization: data.useCookieStorage ? undefined : `Bearer ${data.token}`,
              },
              withCredentials: data.useCookieStorage,
            })
            .then((res) => {
              return transformUserResponse(res.data);
            });
        },
      });
    },
    [axios, queryClient]
  );
}
